import React, { ReactText } from 'react';
import {
  FormItem, RadioButtons, Radio
} from 'elmo-elements';
import { Data, DropDownProps } from '../type';

export type DataProps = {
  handleOnChangeTimeFormat: (value: ReactText) => void;
  handleOnChangeSelect: (e: DropDownProps, name: string) => void;
  handleOnChangeStatus?: (e: DropDownProps) => void;
  data: Data;
};
const TimeFormatSelector = ({
  data,
  handleOnChangeTimeFormat,
}: DataProps) =>
{
  return (
    <FormItem label={'Time format'} isFluid={false} isInline={true}>
        <RadioButtons
          selected={data.time_format}
          onChange={handleOnChangeTimeFormat}
          type={'outlined'}
          direction={'horizontal'}
        >
          <Radio value={'HH:mm'}>HH:MM</Radio>
          <Radio value={'Decimal'}>Decimal</Radio>
        </RadioButtons>
    </FormItem>
  );
};

export default TimeFormatSelector;
